<template>
  <nav class="dashboard-nav">
    <div class="container">
      <ul class="dashboard-nav__list flex gap-s">
        <li v-for="navItem of navList">
          <saffron-link
            v-slot="{ isActive, href, parentActive, exactActive, navigate }"
            class="plain-link"
            :class="navItem.class"
            :to="navItem.to">
            <span>{{ translate(navItem.label) }}</span>
          </saffron-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  props: {
    vendorId: {
      type: [String, Number],
      default: 0,
    },
  },
  data: function () {
    return {
      navList: [
        {
          class: "requires-exact-active",
          to: { name: "company-vendorId-dashboard", params: { id: this.vendorId } },
          label: "justopp.vendorDashboardNav.dashboard",
        },
        {
          class: "",
          to: {
            name: "company-vendorId-dashboard-profile",
            params: { id: this.vendorId },
          },
          label: "justopp.vendorDashboardNav.companyProfile",
        },
        {
          class: "",
          to: {
            name: "company-vendorId-dashboard-products",
            params: { id: this.vendorId },
          },
          label: "justopp.vendorDashboardNav.deals",
        },
        {
          class: "",
          to: {
            name: "company-vendorId-dashboard-brands",
            params: { id: this.vendorId },
          },
          label: "justopp.vendorDashboardNav.brands",
        },
        {
          class: "",
          to: {
            name: "company-vendorId-dashboard-bids",
            params: { id: this.vendorId },
          },
          label: "justopp.vendorDashboardNav.bids",
        },
        {
          class: "",
          to: {
            name: "company-vendorId-dashboard-orders",
            params: { id: this.vendorId },
          },
          label: "justopp.vendorDashboardNav.orders",
        },
        {
          class: "",
          to: {
            name: "company-vendorId-dashboard-statistics",
            params: { id: this.vendorId },
          },
          label: "justopp.vendorDashboardNav.statistics",
        },
        {
          class: "",
          to: {
            name: "company-vendorId-dashboard-manageUsers",
            params: { id: this.vendorId },
          },
          label: "justopp.vendorDashboardNav.manageUsers",
        },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
.dashboard-nav {
  background-color: var(--c-gray-5);
  padding: var(--margin-m) 0;
  color: var(--c-bg);
  position: sticky;
  width: 100%;
  border-bottom: 1px solid var(--c-gray);
  box-shadow: var(--box-shadow);
  overflow-x: auto;
  overflow-y: hidden;
  z-index: var(--z-top-2);

  top: 98px;

  @media (max-width: 1024px) {
    top: 75.8px;
  }

  &__list {
    padding: 0;
    margin: 0;
    list-style: none;

    li {
      display: inline-block;
      white-space: nowrap;
      &::after {
        content: "\00B7";
        color: var(--c-alt);
        margin-inline-start: var(--margin-xl);
        margin-inline-end: var(--margin-xl);
      }

      &:last-of-type {
        &::after {
          display: none;
        }
      }
    }

    a {
      position: relative;
      display: inline-block;
      color: var(--c-bg);

      &:hover,
      &.active:not(.requires-exact-active),
      &.router-link-exact-active {
        color: var(--c-lead);
      }
    }
  }
}
</style>
